import { TypeTileDisplaySkeleton, TypeTileSkeleton } from "#/types/contentful"
import { getIconUrl } from "#/lib/contentful/utils/mappingUtils"
import { EntryWithoutUnresolvableLinks } from "#/utils/ContentTypes"

export type TileDisplay = {
  id: string
  title: string
  description: string
  secondaryDescription: string
  iconUrl: string
  slug: string
}

export type Tile = {
  id: string
  tileDisplay: TileDisplay
}

export const mapContentToTileDisplay = ({
  fields,
  sys
}: EntryWithoutUnresolvableLinks<TypeTileDisplaySkeleton>): TileDisplay => {
  if (!fields || !sys) {
    return null
  }
  const { id } = sys
  const { title, description, secondaryDescription, icon, slug } = fields
  const iconUrl = getIconUrl(icon)

  return {
    id,
    title,
    description,
    secondaryDescription,
    iconUrl,
    slug
  }
}

export const mapContentToTile = ({ fields, sys }: EntryWithoutUnresolvableLinks<TypeTileSkeleton>): Tile => {
  if (!fields || !sys) {
    return null
  }
  const { id } = sys
  const { display } = fields

  return {
    id,
    tileDisplay: mapContentToTileDisplay(display)
  }
}
